
















































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { AppConstants, Models } from "@/core/Export";
import store from "@/store";
@Component({
  components: {},
})
export default class EmployeeAttendViewPairLine extends Vue {
  @Prop() pair;
  constructor() {
    super();
  }

  created() {}

  onShowEmployeeAttendDayPairs(pair: Models.EmployeePairsEntry) {
    if (this.appEnv.UserInfo.isManager && this.isEmployeeDetailsRoute) {
      store.commit(AppConstants.StoreMutations.UpdateDrawerParams, {
        date: pair.date,
      });
      store.commit(AppConstants.StoreMutations.UpdateIsLeftDrawerOpen, true);
      store.commit(
        AppConstants.StoreMutations.UpdateLeftDrawerComponnent,
        AppConstants.DrawerComponnents.EmployeeAttendDayApprove
      );
    }
  }

  isToApprove(text, stateCode) {
    return text && stateCode == AppConstants.EntryExitLogStates.To_Approve;
  }

  isApprove(text, stateCode) {
    return text && stateCode == AppConstants.EntryExitLogStates.Approved;
  }

  get isEmployeeDetailsRoute() {
    return this.$route.name == AppConstants.Routes.M_Employee_Details;
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
